import { AUTHORIZATION } from "../../constants/authorization";
import useAuthorisedEntities from "./useAuthorisedEntities";
import useSelectedLp from "./useSelectedLp";
export function useLpAccessRights() {
    var authorizedEntities = useAuthorisedEntities();
    var lpSelected = useSelectedLp();
    var rights = authorizedEntities === null || authorizedEntities === void 0 ? void 0 : authorizedEntities[lpSelected === null || lpSelected === void 0 ? void 0 : lpSelected.lpId];
    return {
        hasAdminRights: rights === null || rights === void 0 ? void 0 : rights.includes(AUTHORIZATION.ADMIN),
        hasAccessRights: rights === null || rights === void 0 ? void 0 : rights.includes(AUTHORIZATION.ACCESS)
    };
}
export default useLpAccessRights;

//# sourceMappingURL=useLpAccessRights.js.map